import { render, staticRenderFns } from "./itSupport.vue?vue&type=template&id=612c2512&"
import script from "./itSupport.vue?vue&type=script&lang=js&"
export * from "./itSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports